module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFIAAABSBAMAAAA1Ap6oAAAALVBMVEUAAAAfGhcfGhcfGhcfGhcfGhcfGhcfGhcfGhcfGhcfGhcfGhcfGhcfGhcfGhcNqVqJAAAADnRSTlMAMS3r4vDnL+QrTfuVO7GaE/gAAADzSURBVEjH3dWxCoJAAIfxyyVyCsJmBwnXpjYHtyCEXiCopU2CIJpb2qShtwiEXiB6hPZGTRzknqH0BfoO7hD8zx8/uIPjBJq1EHCOfEIykhUrR1Iy1Ep+ZUVJmVFSLimZu+2QsRp50UmOKdlXJF1ABobIGSCPdVhqJf2G3OkkvToshv/D3soQuQXkVY3cUDLTSnpq5KkzpOJdhpT8YHLeDulhMqCkr0aGnSEn+u+SkzElD5ykB98bIjPyUSTwjXPSasizVjKqyzUgHUNkAciBIulScqqTtNTIUiv5pqRIKSnsR0OS3RqSobkr2NK7gLNfKPsC6PBqm4ho89UAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Pr1.png
// module id = g05d
// module chunks = 1